import(/* webpackMode: "eager" */ "/vercel/path1/app/earn/error.tsx");
